window.AjaxPageLoad = (function(window,$){
	var AjaxPageLoad = {};
	AjaxPageLoad.loadPage = function(url, noPush){
		if(noPush || AjaxPageLoad.checkUrl(url)){
			$('.preloader').find('span').css('width','0%');
			$('body').addClass('no-scroll');
			showNavigation(false);
			reconstructImage();
			setTimeout(function(){
				AjaxPageLoad.cleanPage();
				setTimeout(function(){
					window.ajaxLoaded = true;
					AjaxPageLoad.makeRequest(url, noPush);
				});
			}, 1600);
		} else {
			canShatter = true;
			showNavigation(false);
			shatterImage();
		}
	}

	AjaxPageLoad.checkUrl = function(url){
		return url != window.location.pathname;
	}

	AjaxPageLoad.cleanPage = function(){
		//remove old content
		$('body').find('#pageContent').html('');
		$('body').find('#footerContent').html('');
		$('body').find('.main-footer.play').removeClass('play');
		//clear body class
		$('body').removeClass('home pewter history process commercial clients home-notfound news');
		//clear meta titles and descriptions
		$('title').text('');
		$('meta[name="description"]').attr('content','');
		//clear old scripts
		$('#pageScripts').remove();
		$(window).unbind('scroll');
		$(window).unbind('resize');
		$('.overlayVideo').remove();
		$('body').find('#svgIcons').html('');
		ClientLogosSwitcher.destroy();
	}

	AjaxPageLoad.makeRequest = function(url,noPush){
		$.ajax({
            url: url,
            method: "GET",
        }).success(function (data) {
           	var $data = $("<div style='display: none;'>").append($.parseHTML(data, null, true)),
           		_data = {};
           	_data.bodyClass = $data.find('#bodyClass').attr('data-body-class');
        	_data.pageContent = $data.find('#pageContent');
        	_data.footerContent = $data.find('#footerContent');
        	_data.metaTitle = $data.find('title').text();
        	_data.metaDesc = $data.find('meta[name="description"]').attr('content');
        	_data.pageScripts = $data.find('#pageScripts');
        	_data.svgIcons = $data.find('#svgIcons');
            noPush || window.history.pushState({}, '', url);
            try{
        		ga('send', 'pageview');
        	} catch (e) {}
            AjaxPageLoad.loadNewContent(_data);
        }).fail(function () {
        	var _data = {},
        		$tempContent = $('<div>').addClass("notfound-body")
									.append($('<div>').addClass('container notfound-content').attr('id','maincontent')
											.append($('<h1>').html('Page not found! - <span>404</span>'))
											.append($('<p>').html('Sorry the page you are looking for does not exist! Head back to the <a href="/">home page</a> and try again.'))
										   ),
        		$tempFooterContent = $('<div>').addClass("person-section")
									.append($('<div>').addClass("person-img"))
									.append($('<div>').addClass('person-text')
												.append($('<span>').addClass('line-1').html('If I go home'))
												.append($('<span>').addClass('line-2').html('with as many fingers'))
												.append($('<span>').addClass('line-3').html('As I <strong>brought to work</strong>...'))
												.append($('<span>').addClass('line-4').html('...it\'s been a'))
												.append($('<span>').addClass('line-5').html('Good Day!'))
												.append($('<span>').addClass('line-6').html('- Steven, Machine Operator'))
											);
        	_data.bodyClass = "home-notfound";
        	_data.pageContent = $tempContent;
        	_data.footerContent = $tempFooterContent;
        	_data.metaTitle = "404 - Page not found";
        	_data.metaDesc = "The page you are looking for does not exist.";
        	_data.pageScripts = false;
        	noPush || window.history.pushState({}, '', url);
        	try{
        		ga('send', 'pageview');
        	} catch (e) {}
            AjaxPageLoad.loadNewContent(_data);
        });
	}

	AjaxPageLoad.loadNewContent = function(data){
		$('html, body').scrollTop(0);
		$('body').addClass(data.bodyClass);
		$('body').find('#pageContent').html(data.pageContent);
		$('body').find('#footerContent').html(data.footerContent);
		$('title').text(data.metaTitle);
		$('meta[name="description"]').attr('content',data.metaDesc);
		$('body').append(data.pageScripts);
		$('body').find('#svgIcons').html(data.svgIcons);

		bindScrollEvents();
		canShatter = true;
		$('.preloader').removeClass('hidden');
		setTimeout(function(){
			preloadImages(function(){
				shatterImage();
				$('.js-image-preload, .js-bg-preload').removeClass('js-image-preload js-bg-preload');
				$('.js-preload-delayed').removeClass('js-preload-delayed').addClass('js-bg-preload');
				preloadImages(function(){
					$('.js-image-preload, .js-bg-preload').removeClass('js-image-preload js-bg-preload');
				});
			}, updateLoader);
		},1200);
	}


	$(window).on('popstate',function(){
		if((new RegExp("^/news((/[a-zA-Z0-9\-]+)|(/page/[0-9]+))?/?$")).test(window.location.pathname)){
			//We are going to a url containing /news??
			if($('body').find('.news-article-inner.active').length > 0){
				//We are already in an inner news page
				if((new RegExp('^/news(/page/[0-9]+)?/?$')).test(window.location.pathname)){
					//We are going to news.php
					var urlPage = (new RegExp('^/news/page/([0-9]+)/?$')).exec(window.location.pathname);
					if(urlPage != null && $('.js-news-load[data-page-id="' +  urlPage[1] + '"]').length == 0){
						NewsAjaxPageLoad.loadMoreArticles(urlPage[1],true);
					}
					NewsAjaxPageLoad.closeInner(true);
				} else {
					//We are going to a inner news page
					AjaxPageLoad.loadPage(window.location.pathname,true);
				}
			} else if($('body').find('.news-holder').length > 0) {
				//we are on a news page
				if((new RegExp('^/news(/page/[0-9]+)?/?$')).test(window.location.pathname)){
					//We are going to a paginated page
					var urlPage = (new RegExp('^/news/page/([0-9]+)/?$')).exec(window.location.pathname);
					if(urlPage != null && $('.js-news-load[data-page-id="' +  urlPage[1] + '"]').length == 0){
						NewsAjaxPageLoad.loadMoreArticles(urlPage[1],true);
					}
				} else {
					//We are going to a inner news page
					var obj = $('a.js-news-load[href="' + window.location.pathname + '"]');
					NewsAjaxPageLoad.loadPage(obj, window.location.pathname, true);
				}
			} else{ 
				AjaxPageLoad.loadPage(window.location.pathname,true);
			}
		} else {
			AjaxPageLoad.loadPage(window.location.pathname,true);
		}
	});

	return AjaxPageLoad;
})(window,$);